<div class="rst-head">
  <div class="rst-title-block">
    <span class="rst-icon"><i class="bx bx-store-alt" aria-hidden="true"></i></span>
    <div>
      <h3 class="rst-title">Restaurant Status</h3>
      <p class="rst-subtitle">Open or closed right now, from the hours and closed dates</p>
    </div>
  </div>
  @if (canManage && status && !closing) {
    @if (closedNow) {
      <button
        type="button"
        class="rst-btn"
        [disabled]="saving"
        (click)="reopen()"
        data-testid="reopen"
      >
        Reopen now
      </button>
    } @else {
      <button
        type="button"
        class="rst-btn rst-btn--outline"
        [disabled]="saving"
        (click)="openClose()"
        data-testid="close-temporarily"
      >
        Close temporarily
      </button>
    }
  }
</div>

@if (loading && !status) {
  <p class="rst-hint">Checking the restaurant's status…</p>
} @else if (line) {
  <p class="rst-status" [ngClass]="'rst-status--' + line.tone" role="status" data-testid="status">
    <span class="rst-dot" aria-hidden="true"></span>{{ line.text }}
  </p>
} @else {
  <p class="rst-hint" role="alert">The status couldn't be loaded. Reload the page to try again.</p>
}

@if (closing) {
  <div class="rst-close" role="group" aria-labelledby="rst-close-title" data-testid="close-form">
    <span class="rst-close-title" id="rst-close-title">Close the restaurant for now</span>
    <p class="rst-hint">
      No orders, bookings or walk-ins until it reopens. Bookings already made stay booked; let those
      guests know.
    </p>
    <div class="rst-presets" role="radiogroup" aria-label="How long">
      @for (p of presets; track p.value) {
        <label class="rst-preset" [class.rst-preset--on]="preset === p.value">
          <input
            type="radio"
            name="rst-preset"
            [value]="p.value"
            [ngModel]="preset"
            (ngModelChange)="setPreset($event)"
          />
          {{ p.label }}
        </label>
      }
    </div>
    <p class="rst-hint" data-testid="preset-hint">{{ presetHint }}</p>
    @if (bookingsInClosure?.count) {
      <p class="rst-hint rst-hint--warn" role="status" data-testid="bookings-in-closure">
        <i class="bx bx-error-circle" aria-hidden="true"></i>
        {{ bookingsInClosure!.count }}
        {{ bookingsInClosure!.count === 1 ? 'booking falls' : 'bookings fall' }}
        {{ preset === 'reopen' ? 'later today' : 'in this time' }}. They stay booked; let those
        guests know.
        <a
          class="rst-inline-link"
          routerLink="/main/reservation"
          [queryParams]="{ date: bookingsInClosure!.firstDate }"
          >Open the book</a
        >
      </p>
    }
    <label class="rst-reason"
      ><span>Reason <span class="rst-optional">optional</span></span>
      <input
        type="text"
        class="rst-input"
        [(ngModel)]="reason"
        [maxlength]="maxReason"
        placeholder="e.g. Power cut, Staff shortage"
        (keydown.enter)="$event.preventDefault(); confirmClose()"
    /></label>
    <p class="rst-hint"><i class="bx bx-show" aria-hidden="true"></i> Guests see the reason.</p>
    <div class="rst-actions">
      <button
        type="button"
        class="rst-btn"
        [disabled]="saving"
        (click)="confirmClose()"
        data-testid="confirm-close"
      >
        Close restaurant
      </button>
      <button type="button" class="rst-link" (click)="cancelClose()">Cancel</button>
    </div>
  </div>
}
